export default __webpack_public_path__ + "static/media/acc-bg.f8973ca7.svg";